import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

interface AITransparencyLinkProps {
  variant?: "caption" | "body1" | "body2";
}

export const AITransparencyLink = ({ variant = "caption" }: AITransparencyLinkProps) => {
  return (
    <Link
      component={RouterLink}
      to="/ai-transparency"
      variant={variant}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ cursor: "pointer" }}
    >
      Learn More
    </Link>
  );
};
